"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.retrieveClassNamesFromProps = function (variants, styles, props) {
  var suffix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  return variants.filter(function (variant) {
    return props[variant];
  }).map(function (variant) {
    return styles["".concat(variant).concat(suffix)];
  }).join(' ');
};

var STYLE_UTILS = {
  retrieveClassNamesFromProps: exports.retrieveClassNamesFromProps
};
exports.default = STYLE_UTILS;